import { cva } from '@/styled-system/css';

export const adornedInputInputStyles = cva({
  base: {
    'position': 'relative',
    'width': '100%',
    'color': 'text.neutral',
    '_placeholder': {
      color: 'AdornedInput.Input.placeholder',
    },
    '&:autofill': {
      WebkitTextFillColor: 'text.neutral',
      color: 'text.neutral',
    },
    'transition': 'background-color calc(infinity * 1s) step-end',
    'backgroundColor': 'transparent!',
  },
  variants: {
    size: {
      sm: {
        paddingBlock: 'AdornedInput.sm.padding.vert',
      },
      md: {
        paddingBlock: 'AdornedInput.md.padding.vert',
      },
      lg: {
        paddingBlock: 'default',
      },
    },
  },
});
